/**
 * verwirrung_resetAbschnittData
 * @param abschnitt
 * @returns {*}
 */
window.verwirrung_resetAbschnittData = function (abschnitt) {
    abschnitt.find('.section-detail-mittel').remove();
};

/**
 * verwirrung_recalculateSumme
 * @param summeAlt
 * @param alleAbschnitteId
 * @param abschnitte
 * @returns {*&{mittel: {}}}
 */
window.verwirrung_recalculateSumme = function (summeAlt, alleAbschnitteId, abschnitte) {
    const flaeche = alleAbschnitteId.map(id => abschnitte[id]).reduce((a, b) => b.flaeche + a, 0);

    const mittelNeu = {};
    summeAlt.alleMittelId.forEach(mittelId => {
        const mittelmengeNeu = roundMittelmenge(alleAbschnitteId.map(id => abschnitte[id]).map(abschnitt => abschnitt.mittel[mittelId]).reduce((summe, m) => {
            return summe + m.mittelmenge;
        }, 0.0));
        const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu / flaeche * 10000);
        mittelNeu[mittelId] = {
            ...summeAlt.mittel[mittelId],
            mittelmenge: mittelmengeNeu,
            mittelmengeProHa: mittelmengeProHaNeu,
        };
    });

    return {
        ...summeAlt,
        mittel: mittelNeu,
    };
};
